import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { moduleRoutes } from "./modules/modules.routes";
import { LoginComponent } from "./authentication/login/login.component";
import { salesMobileAppRoutes } from "./modules/sales-mobile-app/sales-mobile-app-routing.module";

export const routes: Routes = [
  { path: "", component: LoginComponent },
  {
    path: "",
    canActivate: [MsalGuard],
    children: moduleRoutes,
  },
  {
    path: "sales-mobile-app",
    children: salesMobileAppRoutes,
  },
];
